import axios from "axios";

const BASE_API: string = import.meta.env.VITE_API_BACKEND as string;
const TOKEN: string = import.meta.env.VITE_TOKEN_BE as string;

// รายการ path ที่ไม่ต้องแนบ token
// const EXCLUDE_TOKEN_PATHS = ["/get_ccpp_url"];

const axiosOdoo = axios.create({
  baseURL: BASE_API,
  headers: {
    "Content-Type": "application/json",
  },
});

axiosOdoo.interceptors.request.use((config) => {
  // const isExcluded =
  //   config.url && EXCLUDE_TOKEN_PATHS.some((path) => config.url?.endsWith(path));

  if (
    config.method === "post" &&
    config.data !== undefined &&
    typeof config.data === "object" 
    // && !isExcluded
  ) {
    config.data = {
      ...(config.data as object) as Record<string, unknown>,
      token: TOKEN,
    };
  }
  return config;
});

export default axiosOdoo;
